import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

/** EN / SR toggle for the Cup 2026 landing (dark nav). */
const JuniorCupLangToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="jcup-lang-toggle" role="group" aria-label="Jezik / Language">
      <button
        type="button"
        className={`jcup-lang-toggle__btn${language !== 'sr' ? ' jcup-lang-toggle__btn--active' : ''}`}
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={`jcup-lang-toggle__btn${language === 'sr' ? ' jcup-lang-toggle__btn--active' : ''}`}
        onClick={() => setLanguage('sr')}
      >
        SR
      </button>
    </div>
  );
};

export default JuniorCupLangToggle;
